import {clearFeedbacksByName, getInputsByName} from "../../../helpers/forms";
import Axios from "axios";
import {loading, stopLoading} from "../../../helpers/loading";
import {handleAjaxSuccess} from "../../../helpers/swalHelper";
import handleAjaxError from "../../../helpers/handleAjaxError";

function initClientVoeAttemptsIndex() {
	const fields = [
		'voe_attempt_frequency_hours',
		'voe_attempt_frequency_minutes',
		'max_voe_attempts',
		'max_voe_wait_time_hours',
		'max_voe_wait_time_minutes',
		'voe_contact_email',
		'default_voe_attempt_frequency',
		'default_max_voe_attempts',
		'default_max_voe_wait_time',
		'default_voe_contact_email',
		'process_3rd_party_voe_orders',
		'default_process_3rd_party_voe_orders'
	];


	// Setup events
	document.querySelector('.save-settings-button')
		.addEventListener('click', () => {
			handleSaveSettingsRequest();
		})

	// Events to remove checked from the checkbox on input event

	const flagFields = [
		{
			flag: 'default_voe_attempt_frequency',
			fields: ['voe_attempt_frequency_hours', 'voe_attempt_frequency_minutes']
		},
		{
			flag: 'default_max_voe_attempts',
			fields: ['max_voe_attempts']
		},
		{
			flag: 'default_max_voe_wait_time',
			fields: ['max_voe_wait_time_hours', 'max_voe_wait_time_minutes']
		},
		{
			flag: 'default_voe_contact_email',
			fields: ['voe_contact_email']
		}
	]

	flagFields.forEach(flagFieldContainer => {
		const flagElement = document.getElementById(flagFieldContainer.flag);

		const updateFlagFunction = () => {
			let fieldsFilled = false;
			flagFieldContainer.fields.forEach(field => {
				if (document.getElementById(field).value.trim().length > 0) {
					fieldsFilled = true;
				}
			})

			if (fieldsFilled) {
				removeCheckedFromCheckbox(flagElement);
			} else {
				addCheckedToCheckbox(flagElement);
			}
		}

		// Add events to inputs
		flagFieldContainer.fields.forEach(field => {
			document.getElementById(field).addEventListener('keyup', updateFlagFunction)
		})
	})

	/**
	 * Methods
	 */

	function handleSaveSettingsRequest() {
		clearFeedbacksByName(document.body, fields);

		const data = getInputsByName(document.body, fields);

		loading()

		Axios.post(window['routes/client.settings.voe-attempts.store'], data)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading);
	}

	/**
	 * removes removes checked and adds disabled attributes
	 * @param {HTMLInputElement} checkbox
	 */
	function removeCheckedFromCheckbox(checkbox) {
		if (checkbox.hasAttribute('checked')) {
			checkbox.removeAttribute('checked')
		}
	}

	/**
	 * adds checked attribute and removes disabled attributes
	 * @param {HTMLInputElement} checkbox
	 */
	function addCheckedToCheckbox(checkbox) {
		if (!checkbox.hasAttribute('checked')) {
			checkbox.setAttribute('checked', 'checked')
		}
	}
}

export {initClientVoeAttemptsIndex}
